<template>
  <div class="row">
    <div class="col-md-12">
      <TableWrapper
        :columns="columns"
        :mod-count="modCount"
        :url="url"
        :search-form-fields="formFields"
        :offset-height="offsetHeight"
        :show-add="showAdd"
        :show-del="showDel"
        @on-add="showFormModalDialog"
      />
      <TokenClientDialog
        :id="entityId"
        :visible="modalForm"
        :width="700"
        :action="url"
        @on-close="onModalClose"
      />
    </div>
  </div>
</template>

<script>
import TableWrapper from '@/components/table-wrapper'
import TokenClientDialog from './dialog/tokenDialog'
import request from '@/utils/request'
export default {
  name: 'TokenList',
  components: {
    TableWrapper,
    TokenClientDialog
  },
  data() {
    return {
      url: this.$config.apiContextPath + '/client',
      modalForm: false,
      entityId: 0,
      modCount: 0,
      showAdd: true,
      showDel: true
    }
  },
  computed: {
    offsetHeight() {
      return 280
    },
    formFields() {
      return {
        action: '',
        fields: [
          { label: '客户ID', placeholder: '请输入令牌客户ID...', name: 'clientId', width: 'auto', type: 'input' }
        ]
      }
    },
    columns() {
      const that = this
      return [
        { title: '序号', type: 'index', width: 80, align: 'center' },
        { title: '客户ID', align: 'left', key: 'clientId', sortable: true, ellipsis: true, tooltip: true },
        { title: '客户端范围', align: 'left', key: 'scopes', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { }
            }, params.row.scopes || '---')
          }
        },
        { title: '访问令牌有效期(s)', align: 'left', key: 'accessTokenValiditySeconds', sortable: true, ellipsis: true, tooltip: true },
        { title: '刷新令牌有效期(s)', align: 'left', key: 'refreshTokenValiditySeconds', sortable: true, ellipsis: true, tooltip: true },
        { title: '创建时间', align: 'center', sortable: true, width: 160, key: 'createTime', ellipsis: true, tooltip: true },
        { title: '状态', align: 'center', key: 'enable', sortable: true, ellipsis: true, tooltip: true,
          render: (h, params) => {
            return h('span', {
              style: { }
            }, params.row.enable ? '启用' : '停用')
          }
        },
        { title: '操作', align: 'center', width: 185,
          render: (h, params) => {
            return h('div', [
              h('a', {
                style: { color: '#126D91', marginRight: '10px' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showFormModalDialog(params.row.id)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-edit': true, 'cell-icon-link': true }}),
                h('span', {}, '编辑')
              ]),
              that.showDel ? h('a', {
                style: { color: '#126D91' },
                on: {
                  click: () => {
                    if (params.row.id) {
                      this.showDelModalDialog(params.row.id, params.row.clientId)
                    }
                  }
                }
              }, [
                h('i', { class: { 'fas': true, 'fa-trash': true, 'cell-icon-link': true }}),
                h('span', {}, '删除')
              ]) : h()
            ])
          }
        }
      ]
    }
  },
  methods: {
    showFormModalDialog: function(id = '') {
      this.entityId = id ? parseInt(id) : 0
      this.modalForm = true
    },
    showDelModalDialog: function(id, clientId) {
      const _this = this
      this.$Modal.confirm({
        title: '确认删除令牌客户信息么？',
        loading: true,
        render: (h, params) => {
          return h('ul', { style: { padding: '10px 25px 0' }}, [h('li', {}, clientId)])
        },
        onOk: function() {
          request({
            url: _this.url + '/' + id,
            method: 'DELETE'
          }).then(res => {
            this.$Notice.success({
              title: '数据删除成功',
              desc: '令牌客户 `' + clientId + '` 删除成功!'
            })
            _this.modCount = _this.modCount + 1
            this.$Modal.remove()
          }).catch(error => {
            this.$Notice.error({
              title: '数据删除失败',
              desc: '令牌客户 `' + clientId + '` 删除失败, 错误信息: ' + error
            })
          })
        }
      })
    },
    onModalClose: function(changed) {
      this.entityId = 0
      this.modalForm = false
      if (changed) {
        this.modCount = this.modCount + 1
      }
    }
  }
}
</script>

